import { useMemo } from 'react';
import { ENV_CONFIG } from '../constants';
import { FeatureFlags } from '../types';

/**
 * Custom hook to access feature flags and environment configuration
 */
export const useFeatureFlags = () => {
  const featureFlags: FeatureFlags = useMemo(() => ({
    comingSoon: ENV_CONFIG.comingSoon,
    maintenanceMode: ENV_CONFIG.maintenanceMode,
  }), []);

  const isPageExcluded = (pathname: string): boolean => {
    return ENV_CONFIG.excludedPages.some(excludedPath => 
      pathname.startsWith(excludedPath)
    );
  };

  const shouldShowComingSoon = (pathname: string): boolean => {
    return featureFlags.comingSoon && !isPageExcluded(pathname);
  };

  const shouldShowMaintenance = (): boolean => {
    return featureFlags.maintenanceMode;
  };

  return {
    featureFlags,
    isPageExcluded,
    shouldShowComingSoon,
    shouldShowMaintenance,
    config: ENV_CONFIG,
  };
};
